/* eslint-disable import/no-default-export */
import React from 'react';

const SelectionModeIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <g fill={props.color || 'currentColor'} fillRule="evenodd">
      <path d="M1894.604 739.703C1911.214 810.44 1920 884.194 1920 960c0 530.193-429.807 960-960 960S0 1490.193 0 960 429.807 0 960 0c187.27 0 362.017 53.622 509.723 146.35l-175.67 175.67a716.36 716.36 0 0 0-68.536-31.48C1143.358 257.925 1053.773 240 960 240c-397.645 0-720 322.355-720 720s322.355 720 720 720 720-322.355 720-720c0-1.892-.007-3.783-.022-5.672l214.626-214.625z" />
      <path d="M481.239 965.136c-46.865-46.865-46.864-122.85-.004-169.71 46.863-46.863 122.846-46.86 169.71.004l339.403 339.404c46.865 46.865 46.864 122.85.004 169.71-46.863 46.862-122.846 46.859-169.71-.004L481.24 965.136z" />
      <path d="M820.646 1304.543c-46.863-46.863-46.86-122.844 0-169.705l763.676-763.676c46.863-46.863 122.845-46.86 169.705 0 46.863 46.863 46.862 122.845 0 169.706l-763.675 763.676c-46.863 46.862-122.846 46.86-169.706 0z" />
    </g>
  </svg>
);

export default SelectionModeIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/SelectionModeIcon.js